


















































import { computed, defineComponent, ref, set } from "@vue/composition-api";
import { debounce } from "lodash";
import { PushCategory } from "@scrile/api-provider/dist/api/PushNotificationsProvider";
import providers from "@/lib/api";
import { getNotificationsPermissions, isIOS, isNotificationsSupported } from "@/lib/browserUtils";
import { $t } from "@/lib/i18nHelpers";
import { FormFields, FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PagePushNotificationsSettings",
  components: { BaseIcon, PageTitle, BasePage, BaseForm },
  setup() {
    const values = ref<FormValues>({ allPushes: false });
    const pushSettings = ref<Partial<Record<PushCategory, boolean>> | null>(null);
    const loading = ref(true);
    const notificationPermission = ref(getNotificationsPermissions());

    const fields: FormFields = [
      {
        class: "__allPushes mt-0 mb-1",
        name: "allPushes",
        label: $t("Push notifications"),
        type: "switch",
        hint: $t("Turn on to find out what’s going on when you’re not on JustStars. You can turn off anytime."),
      },
    ];

    const save = debounce(async () => {
      const updatedSettings = {} as Record<PushCategory, boolean>;
      for (let key in pushSettings.value) {
        set(updatedSettings, key, values.value.allPushes);
      }
      const { settings } = await providers.PushNotificationsProvider.settingsUpdate({
        data: { settings: updatedSettings },
      });
      pushSettings.value = settings;
    }, 500);
    const handleInput = (newValues: FormValues) => {
      if (isNotificationsSupported() && notificationPermission.value !== "granted" && newValues.pushNotifications) {
        Notification.requestPermission().then(r => (notificationPermission.value = r));
      }
      values.value = newValues;
      save();
    };
    const init = async () => {
      try {
        const { settings } = await providers.PushNotificationsProvider.settingsFind();
        pushSettings.value = settings;
        if (Object.values(settings).some(e => e)) {
          values.value.allPushes = true;
        }
      } finally {
        loading.value = false;
      }
    };
    init();

    const showInstructions = computed(() => isIOS() && notificationPermission.value !== "granted");

    return { notificationPermission, fields, values, loading, handleInput, showInstructions };
  },
});
